export const MEDIA_UNAVAILABLE_TEXT = 'Image will be available soon';

export const getMediaUnavailableText = (t) => (
  t?.('questDetails.mediaUnavailable', MEDIA_UNAVAILABLE_TEXT) || MEDIA_UNAVAILABLE_TEXT
);

export const hasDisplayableMedia = ({ imageUrl, videoUrl } = {}) => {
  const image = typeof imageUrl === 'string' ? imageUrl.trim() : '';
  const video = typeof videoUrl === 'string' ? videoUrl.trim() : '';
  return Boolean(image || video);
};
